import images from '@/assets/getAssets';
import { cn } from '@/lib/utils';
import { ArrowLeft, CloudRainWind, Thermometer } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Separator } from '../shadcn-ui/separator';
import { format } from 'date-fns';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [coords, setCoords] = useState({ lat: null, lon: null });
  const [weather, setWeather] = useState(null);
  const [rainChance, setRainChance] = useState(null); // %

  const API_KEY = import.meta.env.VITE_WEATHER_API_KEY;

  const now = new Date();

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      position => {
        console.log('Geolocation success:', position);
        setCoords({
          lat: position.coords.latitude,
          lon: position.coords.longitude,
        });
      },
      error => {
        console.error('Location error:', error.code, error.message);
      },
      { enableHighAccuracy: true }
    );
  }, []);

  useEffect(() => {
    console.log('coords state:', coords);
    if (!coords.lat || !coords.lon) return;

    const fetchWeather = async () => {
      try {
        // current weather
        const currentRes = await fetch(
          `https://api.openweathermap.org/data/2.5/weather?lat=${coords.lat}&lon=${coords.lon}&units=metric&appid=${API_KEY}`
        );
        const currentData = await currentRes.json();
        setWeather(currentData);

        // forecast (to get rain probability)
        const forecastRes = await fetch(
          `https://api.openweathermap.org/data/2.5/forecast?lat=${coords.lat}&lon=${coords.lon}&units=metric&appid=${API_KEY}`
        );
        const forecastData = await forecastRes.json();

        if (forecastData.list && forecastData.list.length > 0) {
          // Take the next 3-hour forecast block
          const nextBlock = forecastData.list[0];
          // pop is 0–1 → convert to %
          const pop = nextBlock.pop ?? 0;
          setRainChance(Math.round(pop * 100));
        }
      } catch (err) {
        console.error('Weather API error:', err);
      }
    };

    fetchWeather();
  }, [coords]);

  return (
    <nav className="z-50 border-b border-gray-200 bg-white px-4 py-4 shadow-sm">
      <div className="flex">
        <div className="pr-[10px]">
          <button
            onClick={() => navigate(-1)}
            className={cn('p-[10px] pl-0', location.pathname === '/' && 'invisible')}
          >
            <ArrowLeft className="h-6 w-6" />
          </button>
        </div>

        <div className="w-full">
          <div className="flex flex-1 items-center justify-between">
            {/*  */}
            <div className="">
              <div className="text-lg font-medium leading-8">{format(now, 'EEEE, MMMM d')}</div>
              <div className="text-sm font-normal">{format(now, 'hh:mm a')}</div>
            </div>

            {/* logo */}
            <div className="mr-3 h-auto w-14 md:w-20">
              <img src={images['so_coffee_logo.png']} alt="So, Coffee? logo" className="mr-3 w-full leading-none" />
            </div>
          </div>

          {/* Temperature */}
          <div className="mt-2 flex items-center gap-3">
            <div className="flex items-center">
              <Thermometer className="h-6 w-6" />
              <span>{weather?.main.temp}°C</span>
            </div>

            <Separator orientation="vertical" className="h-6 w-[2px] bg-slate-300" />

            <div className="flex items-center gap-1">
              <CloudRainWind className="h-6 w-6" />
              <span>{rainChance}%</span>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
